module.exports = __webpack_public_path__ + "static/media/sm_2.5ae0b273.svg";